<template>
  <div class="container mt-5">
    <div
      class="residentportal-filter-bar row mb-4"
      v-if="
        workOrderRecords &&
        (serviceFilter ||
          (Object.keys(workOrderRecords) &&
            Object.keys(workOrderRecords).length > 0))
      "
    >
      <div class="col-lg-6"></div>
      <div class="col-lg-6">
        <div class="d-flex flex-wrap">
          <span>Filter: &nbsp;</span>
          <select
            style="border-color: #dfdfdf; flex: 1"
            v-model="serviceFilter"
          >
            <option selected="" :value="null">All</option>
            <option
              v-for="option in serviceFilterOptions.filter(x => x.isDisplay)"
              :key="option.id"
              :value="option.name"
            >
              {{ option.name }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="accordion mt-2" id="accordionExample">
      <div
        class="card"
        v-for="(workOrderRecord, key, i) in workOrderRecords"
        :key="key"
      >
        <a
          :class="
            i == 0
              ? 'card-header card-link  text-dark'
              : 'card-header collapsed card-link  text-dark'
          "
          :id="'heading-' + i"
          data-bs-toggle="collapse"
          :data-bs-target="'#collapse-' + i"
          :href="'#collapse' + key"
          aria-expanded="true"
          :aria-controls="'collapse-' + i"
        >
          <h2 class="mb-0 font-md">
            <span class="font-weight-bold">{{
              workOrderRecord.rankedStatus
            }}</span>
            <span
              v-if="
                showStatusReference &&
                isShowWooStatusReasonDesc(workOrderRecord.woStatusReasonDesc)
              "
              class="font-weight-bold"
              >- {{ workOrderRecord.woStatusReasonDesc }}</span
            >
            <span class="d-none d-md-inline-block">-</span>
            <span>{{ workOrderRecord.CRN }} </span>
            <span>{{ workOrderRecord.getDisplayServiceName() }}</span>
            <span v-if="workOrderRecord.entitlementsClaimed">
              X {{ workOrderRecord.entitlementsClaimed }}</span
            >
            <span
              >&nbsp;{{ getFormattedDate(workOrderRecord.displayDate) }}</span
            >
          </h2>
        </a>

        <div
          :id="'collapse-' + i"
          :class="i == 0 ? 'collapse show' : 'collapse'"
          :aria-labelledby="'heading-' + i"
          data-bs-parent="#accordionExample"
          :data-bs-collapse-node="i"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-xs-12 col-md-8">
                <span class="font-weight-bold">Booking Details</span>
                <div class="booking-details mb-4">
                  <!-- Weekly Date Display -->
                  <div
                    v-if="workOrderRecord.requestedStartDate"
                    class="booking-details__date vw-small text-center"
                  >
                    <div class="d-inline-block d-md-flex">
                      <strong>
                        {{ workOrderRecord.requestedStartDate.day }}
                      </strong>
                      &nbsp;{{
                        workOrderRecord.requestedStartDate.getMonthDesc()
                          ? workOrderRecord.requestedStartDate
                              .getMonthDesc()
                              .substring(0, 3)
                          : workOrderRecord.requestedStartDate.getMonthDesc()
                      }}
                    </div>
                    <div class="d-inline-block d-md-block px-2">to</div>
                    <div class="d-inline-block d-md-flex">
                      <strong>
                        {{ workOrderRecord.woRequestedDateTime | moment("DD") }}
                      </strong>
                      &nbsp;
                      {{ workOrderRecord.woRequestedDateTime | moment("MMM") }}
                    </div>
                  </div>

                  <!-- Daily Date Display -->
                  <div v-else class="booking-details__date">
                    <span class="font-weight-bold">
                      {{ workOrderRecord.woRequestedDateTime | moment("DD") }}
                    </span>
                    {{ workOrderRecord.woRequestedDateTime | moment("MMMM") }}
                  </div>

                  <div class="booking-details__info notranslate">
                    <span class="font-weight-bold"
                      ><i aria-hidden="true" class="icon icon-pin mr-2"></i
                      >{{ addressDetails.displayName }}</span
                    >
                    <!--span>Kerbside Collection</span-->
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 booking-reference mb-4">
                    <span
                      class="booking-reference__title font-weight-bold d-block mb-2"
                      >{{ isMelton ? 'DATE OF SUBMISSION' : 'BOOKING DATE' }}</span
                    >
                    <div class="booking-reference__date">
                      {{ getFormattedDate(workOrderRecord.woCreatedDateTime) }}
                    </div>
                  </div>
                  <!-- 
                    REMOVING THIS AS PER BA's INSTRUCTIONS FOR P2US440 - Franco
                    
                  <div class="col-md-4 booking-reference">
                    <span class="booking-reference__title font-weight-bold d-block mb-2">REF NO</span>
                    <div class="booking-reference__refno">{{workOrderRecord.CRN}}</div>
                  </div> -->
                  <div class="col-md-8 booking-reference mb-4">
                    <span
                      class="booking-reference__title font-weight-bold d-block mb-2"
                      >WASTE</span
                    >
                    <!-- On mounted, this waste list does not exist if it's panel is not open. Unless it's the first panel which is always open onmounted. -->
                    <div
                      v-for="(workOrder, wi) in (
                        i === collapsedNode ||
                        (collapsedNode === null && i === 0)
                          ? workOrderRecord.orders
                          : []
                      )"
                      v-bind:key="wi"
                      class="booking-reference__waste"
                    >
                      <EllipsisParagraph
                        v-if="
                          workOrderRecord.getDisplayWasteStreamName(
                            workOrder.woWasteType
                          ) != 'hidestream'
                        "
                        :lines='4'
                      >
                        <p
                          v-if="
                            parseInt(workOrder.woAmountPaid) == 0 &&
                            getWorkOrderSelectedOption(workOrder, wi) != '' &&
                            wi == showWooStatusReasonDescFreeIndex &&
                            showWorkOrderSelectedOption
                          ">
                          {{ getWorkOrderSelectedOption(workOrder, wi) }}
                        </p>
                        <span>{{
                          workOrderRecord.getDisplayWasteStreamName(
                            workOrder.woWasteType
                          ) + (
                            isShowWooStatusReasonDesc(workOrder.woStatusReasonDesc)
                              ? " - " + workOrder.woStatusReasonDesc
                              : ""
                          )
                        }}</span>
                        <li
                          v-if="
                            parseInt(workOrder.woAmountPaid) > 0 &&
                            getWorkOrderSelectedOption(workOrder, wi) != '' &&
                            showWorkOrderSelectedOption
                          ">
                          {{ getWorkOrderSelectedOption(workOrder, wi) }}
                        </li>
                      </EllipsisParagraph>
                    </div>
                  </div>
                </div>
                <!--Woi Items-->
                <div v-if="workOrderRecord.hasWoi" class="row">
                  <div class="col-md-8 booking-reference mb-4">
                    <span
                      class="booking-reference__title font-weight-bold d-block mb-2"
                      >SELECTED OPTION</span
                    >
                    <div
                      v-for="(workOrder, wi) in i === collapsedNode ||
                      (collapsedNode === null && i === 0)
                        ? workOrderRecord.orders
                        : []"
                      v-bind:key="wi"
                      class="booking-reference__waste"
                    >
                      <EllipsisParagraph v-if="workOrder.hasWoi">
                        {{
                          getWoiWasteTypeName(
                            workOrder.WOIWasteType,
                            workOrder.WOISize,
                            workOrder.WOIUOM
                          ) + (
                            isShowWooStatusReasonDesc(workOrder.woStatusReasonDesc)
                              ? " - " + workOrder.woStatusReasonDesc
                              : ""
                          )
                        }}
                      </EllipsisParagraph>
                    </div>
                  </div>
                  <div class="col-md-4 booking-reference mb-4">
                    <span
                      class="booking-reference__title font-weight-bold d-block mb-2"
                      >ITEM TYPE</span
                    >
                    <div
                      v-for="(workOrder, wi) in i === collapsedNode ||
                      (collapsedNode === null && i === 0)
                        ? workOrderRecord.orders
                        : []"
                      v-bind:key="wi"
                      class="booking-reference__waste"
                    >
                      <EllipsisParagraph v-if="workOrder.hasWoi">
                        {{
                          workOrder.WOIType + (
                            isShowWooStatusReasonDesc(workOrder.woStatusReasonDesc)
                              ? " - " + workOrder.woStatusReasonDesc
                              : ""
                          )
                        }}
                      </EllipsisParagraph>
                    </div>
                  </div>
                </div>
                <!--ONLY FOR CSO-->
                <div
                  v-if="$store.getters.GET_PERSONAL_INFO.type === 'cso'"
                  class="row"
                >
                  <div class="col-md-4 booking-reference mb-4">
                    <span
                      class="booking-reference__title font-weight-bold d-block mb-2"
                      >CUSTOMER NAME</span
                    >
                    <div class="booking-reference__refno">
                      <EllipsisParagraph :lines="2">{{
                        workOrderRecord.Comments
                      }}</EllipsisParagraph>
                    </div>
                  </div>
                  <div class="col-md-4 booking-reference mb-4">
                    <span
                      class="booking-reference__title font-weight-bold d-block mb-2"
                      >EMAIL</span
                    >
                    <div class="booking-reference__date">
                      <EllipsisParagraph :lines="2">{{
                        workOrderRecord.emailaddress
                      }}</EllipsisParagraph>
                    </div>
                  </div>
                  <div class="col-md-4 booking-reference mb-4">
                    <span
                      class="booking-reference__title font-weight-bold d-block mb-2"
                      >PHONE NUMBER</span
                    >
                    <div class="booking-reference__waste">
                      <EllipsisParagraph :lines="2">{{
                        workOrderRecord.phonenumber
                      }}</EllipsisParagraph>
                    </div>
                  </div>
                </div>
                
                <div
                  v-if="$store.getters.GET_PERSONAL_INFO.type === 'cso'"
                  class="row"
                >
                   <div class="col-md-4 booking-reference mb-4">
                    <span
                      class="booking-reference__title font-weight-bold d-block mb-2"
                      >CSO</span
                    >
                    <div class="booking-reference__date">
                      {{ workOrderRecord.receivingAgent }}
                    </div>
                  </div>
                  <div v-if="displayBookingComment" class="col-md-8 booking-reference mb-4">
                    <span
                      class="booking-reference__title font-weight-bold d-block mb-2"
                      >COMMENT</span
                    >
                    <div class="booking-reference__date">
                      {{ getWorkOrderComment(workOrderRecord) }}
                    </div>
                  </div>
                </div>
                <!--ONLY FOR CSO-->
              </div>
              <div
                v-show="
                  workOrderRecord.isPaid == '2' && !forceHidePaymentDetails
                "
                class="col-xs-12 col-md-4"
              >
                <span class="font-weight-bold">Amount</span>
                <table class="table mt-2 table-amount">
                  <tbody>
                    <tr>
                      <td class="text-left">Subtotal</td>
                      <td class="text-right">
                        ${{
                          (
                            workOrderRecord.woAmountPaid /
                            (1 +
                              parseInt(
                                $store.getters.GET_GST_DATA.list[0]
                                  .gst_setting_percent
                              ) /
                                100)
                          ).toFixed(2)
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left">GST</td>
                      <td class="text-right">
                        ${{
                          (
                            workOrderRecord.woAmountPaid -
                            workOrderRecord.woAmountPaid /
                              (1 +
                                parseInt(
                                  $store.getters.GET_GST_DATA.list[0]
                                    .gst_setting_percent
                                ) /
                                  100)
                          ).toFixed(2)
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table class="table mt-4 table-amount">
                  <tbody>
                    <tr>
                      <td class="text-left font-weight-bold">TOTAL AMOUNT</td>
                      <td class="text-right font-weight-bold">
                        ${{ workOrderRecord.woAmountPaid.toFixed(2) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BookingStateManager from "../../../../common/utils/BookingStateManager";
import DateNoTz from "../../../../common/utils/DateNoTz";
import WorkOrderRecord from "../../../../common/utils/WorkOrderRecord";
import EllipsisParagraph from "../../../../common/components/EllipsisParagraph";
import helper from "../../../../helper";

export default {
  components: {
    EllipsisParagraph,
  },
  data() {
    return {
      activeAddress: [],
      collapsedNode: 0,
      allWoiWasteTypes: [],
      bookingReferenceEntitlementsClaimedHash: {},
      woStatusRanks: [],
      serviceFilter: null,
      showWooStatusReasonDescFreeIndex: -1
    };
  },
  mounted() {
    this.$store.dispatch("getGSTData");
    this.$store.dispatch("getServices");
    this.$store.dispatch("getAllWasteStreams");
    this.$store.dispatch("getWasteComboList");
    this.$store.dispatch("getAllWoiWasteType").then((data) => {
      this.allWoiWasteTypes = data;
    });
    this.$store.dispatch("getWoStatusRank").then((data) => {
      // -- Format as array
      var list = data ? data.list : null;
      if (list && Array.isArray(list)) {
        list = list.sort((a, b) => a.rank - b.rank);
        this.woStatusRanks = list.map((statusRank) => statusRank.status);
      }
    });

    // Address ID
    var activeAddressId = this.activeAddressId;
    this.$store.dispatch("getWorkOrder", activeAddressId);
    this.$store.dispatch("getAddressEntitlementV3", activeAddressId);

    // Let's detect if a collapse panel will be shown during the user interaction on this page
    let self = this;
    $("#accordionExample").on("shown.bs.collapse", function () {
      // Get the current showing panel
      const showing = document.querySelector(".collapse.show");

      if (showing) {
        // Current showing panel is surely has waste stream list inside.
        // This will result to re-evaluation of waste stream list
        // so the ellipsis detection will evaluate again the waste list items
        self.collapsedNode = parseInt(
          showing.getAttribute("data-bs-collapse-node")
        );
      }
    });
  },
  computed: {
    isMelton() {
      return helper.getPortalName() == "melton";
    },
    bookingSetting() {
      return this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_BOOKING_SETTING
    },
    personalInfo: function() {
      return this.$store.getters.GET_PERSONAL_INFO;
    },
    activeAddressId() {
      return this.$route.query.id;
    },
    workOrderObject: function () {
      return this.$store.getters.GET_WORK_ORDER;
    },
    workOrderAddressId: function () {
      return this.workOrderObject ? this.workOrderObject.id : null;
    },
    workOrders: function () {
      return this.workOrderObject ? this.workOrderObject.workOrders : null;
    },
    allWasteStreams() {
      var wasteStreams = this.$store.getters.GET_ALL_WASTE_STREAMS;
      return wasteStreams.list;
    },
    woiWasteTypes() {
      var wasteStreams = this.$store.getters.GET_WOI_WASTE.list;
      return wasteStreams.list;
    },
    allServices() {
      return this.$store.getters.GET_SERVICES.list;
    },
    allWasteStreamCombos() {
      return this.$store.getters.GET_WASTE_COMBO_LIST.list;
    },
    workOrderRecords: function () {
      var workOrders = this.workOrders;
      var workOrderRecords = {};
      var activeAddressId = this.$route.query.id;

      // Prevent Null Exceptions
      if (!workOrders || this.workOrderAddressId != activeAddressId) {
        return workOrderRecords;
      }

      // Group the work orders by CRN
      var historyDetails = this.groupWorkOrders(workOrders);

      // Iterate over each entry
      for (var key in historyDetails) {
        var workOrder = historyDetails[key];

        // Find a Matching Service Waste Stream
        var displayNames = this.findWorkOrderDisplayNames(workOrder);

        var serviceNoDisplay = this.serviceFilterOptions
          .filter(x => !x.isDisplay)
          .map(x => x.name.toLowerCase().trim());

        // Hide workorder if service no display
        if(
          displayNames.service_name &&
          serviceNoDisplay.includes(displayNames.service_name.toLowerCase().trim())
        ) {
          continue;
        }
        /*
          Stry: [US444] As a user, I want to filter the booking history by service type
          Date: 2020-01-13
          Auth: Franco Mapua
          Desc: Filtering work orders by service names
        */
        if (
          this.serviceFilter &&
          displayNames.service_name &&
          this.serviceFilter.toLowerCase() !=
            displayNames.service_name.toLowerCase()
        ) {
          continue;
        }

        var workOrderRecord = new WorkOrderRecord(workOrder, displayNames);
        workOrderRecords[key] = workOrderRecord;
      }

      /*
        Stry: [US441] As a user, I want to see the entitlements consumed by a booking group
        Date: 2020-01-11
        Auth: Franco Mapua
        Desc: Adding entitlementsClaimed to the work order records
      */
      if (this.bookingReferenceEntitlementsClaimedHash) {
        for (var key in workOrderRecords) {
          var workOrderRecord = workOrderRecords[key];

          if (
            this.bookingReferenceEntitlementsClaimedHash[workOrderRecord.CRN]
          ) {
            workOrderRecord.entitlementsClaimed = this.bookingReferenceEntitlementsClaimedHash[
              workOrderRecord.CRN
            ];
          }
        }
      }

      /*
        Format the CRNs
      */
      for (var key in workOrderRecords) {
        workOrderRecords[key].CRN  = this.formatCrnForPrint(workOrderRecords[key].CRN);
      }
    
      this.collapsedNode = null;
      return workOrderRecords;
    },
    serviceWasteStreamHash() {
      var hash = [];

      if (this.allServices && this.allWasteStreams) {
        var services = this.allServices;
        var wasteStreams = this.allWasteStreams;
        var wasteStreamCombos = this.allWasteStreamCombos;

        for (let i = 0; i < services.length; i++) {
          services[i].wasteStreams = [];
          services[i].wasteStreamCombos = [];
          for (let j = 0; j < wasteStreams.length; j++) {
            if (
              services[i].service_setting_id ==
              wasteStreams[j].service_setting_id
            ) {
              services[i].wasteStreams.push(wasteStreams[j]);
            }
          }
          for (let j = 0; j < wasteStreamCombos.length; j++) {
            if (
              services[i].service_setting_id ==
              wasteStreamCombos[j].service_setting_id
            ) {
              services[i].wasteStreamCombos.push(wasteStreamCombos[j]);
            }
          }
        }

        var servicesHash = [];

        for (let i = 0; i < services.length; i++) {
          var condensedService = {
            service_setting_id: services[i].service_setting_id,
            service_name: services[i].service_name,
            api_value: services[i].api_value,

            // Date Selection Values
            date_selection: services[i].date_selection,
            weekly_start_day: services[i].weekly_start_day,

            wasteStreams: [],
            wasteStreamCombos: [],
          };
          services[i].wasteStreams.forEach((wasteStream) => {
            condensedService.wasteStreams.push({
              waste_stream_setting_id: wasteStream.waste_stream_setting_id,
              waste_stream_name: wasteStream.waste_stream_name,
              api_value: wasteStream.api_value,
              is_hidden: !wasteStream.is_cso && !wasteStream.is_res,
            });
          });
          services[i].wasteStreamCombos.forEach((wasteStreamCombo) => {
            var primary_waste_stream = wasteStreamCombo.primary_waste_stream;
            condensedService.wasteStreamCombos.push({
              primary_waste_stream_setting_id:
                primary_waste_stream.waste_stream_setting_id,
              primary_waste_stream_name: primary_waste_stream.waste_stream_name,
              primary_waste_stream_api_value: primary_waste_stream.api_value,
              api_value: wasteStreamCombo.api_value,
            });
          });

          servicesHash.push(condensedService);
        }

        servicesHash = servicesHash.sort((a, b) => {
          var textA = a.api_value.toUpperCase();
          var textB = b.api_value.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });

        hash = servicesHash;
      }

      return hash;
    },
    addressDetails: function () {
      if (this.$store.getters.GET_ACTIVE_ADDRESS != null) {
        this.activeAddress = "";
        this.activeAddress = this.$store.getters.GET_ACTIVE_ADDRESS;
        localStorage.setItem(
          "ActiveAddress",
          JSON.stringify(this.activeAddress)
        );
        return this.activeAddress;
      } else {
        var address = null;
        var urlQuery = this.$route.query;
        var addressId = urlQuery.id;
        if (addressId != null) {
          var bookingManager = new BookingStateManager();
          address = bookingManager.getAddressFromMapById(addressId);
        }

        return address;
      }
    },
    forceHidePaymentDetails() {
      return false;
      // return helper.getPortalName() === 'cardinia'
    },
    showStatusReference() {
      // Enables grouping by and display of woStatusReferenceDesc for each Work Order
      return helper.getPortalName() === helper.PORTALS.HILLSHIRE;
    },
    showWorkOrderSelectedOption() {
      return helper.getPortalName() === helper.PORTALS.MAROONDAH;
    },
    addressEntitlementsList() {
      return this.$store.getters.GET_ADDRESS_ENTITLEMENT.list;
    },
    serviceFilterOptions() {
      var options = [];

      if (Array.isArray(this.allServices)) {
        options = this.allServices.map((service) => {
          return {
            id: service.service_setting_id,
            apiValue: service.api_value,
            name: service.service_name,
            isDisplay: !!service.display_in_history || (
              this.personalInfo &&
              this.personalInfo.type &&
              this.personalInfo.type.toLowerCase().trim() == 'cso'
            )
          };
        });
      }
      return options;
    },
    displayBookingComment() {
      return !!this.bookingSetting.display_booking_comment;
    },
  },
  methods: {
    getPaidStatus(serviceName) {
      for (let i = 0; i < this.$store.getters.GET_SERVICES.list.length; i++) {
        if (
          this.$store.getters.GET_SERVICES.list[i].api_value.toLowerCase() ==
          serviceName.toLowerCase()
        ) {
          return this.$store.getters.GET_SERVICES.list[i].is_paid;
        }
      }
    },
    getWoiWasteTypeName(WOIWasteType, WOISize, WOIUOM) {
      // Pulls the WOIWasteName from Voyager based on Type, Size, and UOM
      var allWoiWasteTypes = this.allWoiWasteTypes;
      var foundWoiWasteType = allWoiWasteTypes.find((woiWasteType) => {
        var woiObject = woiWasteType.woi_waste_type;
        return (
          woiObject &&
          woiObject.api_value == WOIWasteType &&
          woiObject.api_size == WOISize &&
          woiObject.api_uom == WOIUOM
        );
      });
      if (foundWoiWasteType && foundWoiWasteType.woi_waste_type) {
        return foundWoiWasteType.woi_waste_type.woi_waste_name;
      } else {
        return `${WOIWasteType} ${WOISize} ${WOIUOM}`;
      }
    },
    groupWorkOrders(workOrders) {
      let workOrderGroups = {};
      workOrders.forEach((workOrder) => {
        var orderKey = `${workOrder.CRN}-${workOrder.woServiceType}`;

        // --- HillShire-Specific grouping
        if (this.showStatusReference) {
          orderKey = `${workOrder.CRN}-${workOrder.woServiceType}-${workOrder.woStatus}-${workOrder.woStatusReasonDesc}`;
        }

        if (!workOrderGroups[orderKey]) {
          workOrderGroups[orderKey] = {
            ...workOrder,
          };
          workOrderGroups[orderKey].woEntitlement = parseInt(
            workOrder.woEntitlement
          );
          workOrderGroups[orderKey].woAmountPaid = parseFloat(
            workOrder.woAmountPaid
          );
          workOrderGroups[orderKey].isPaid = this.getPaidStatus(
            workOrder.woServiceType
          );
          workOrderGroups[orderKey].orders = [workOrder];
        } else {
          const foundGroup = workOrderGroups[orderKey];

          foundGroup.woEntitlement += parseInt(workOrder.woEntitlement);
          foundGroup.woAmountPaid += parseFloat(workOrder.woAmountPaid);
          foundGroup.orders.push(workOrder);
        }
        if (workOrder.WOIWasteType && workOrder.WOIWasteType != "") {
          workOrder.hasWoi = true;
          workOrderGroups[orderKey].hasWoi = true;
        }

        // --- Display Date
        var createDate =
          workOrder.woCreatedDateTime != ""
            ? workOrder.woCreatedDateTime
            : null;
        var scheduleDate =
          workOrder.woScheduledDateTime != ""
            ? workOrder.woScheduledDateTime
            : null;
        var completeDate =
          workOrder.woCompletedDateTime != ""
            ? workOrder.woCompletedDateTime
            : null;

        // Safari-Friendly Selection
        var displayDate;
        if (completeDate) {
          displayDate = completeDate;
        } else if (scheduleDate) {
          displayDate = scheduleDate;
        } else if (createDate) {
          displayDate = createDate;
        }

        if (!workOrderGroups[orderKey].displayDate) {
          workOrderGroups[orderKey].displayDate = displayDate;
        } else {
          var origDate = new Date(
            this.toSafariDate(workOrderGroups[orderKey].displayDate)
          );
          var newDate = new Date(this.toSafariDate(displayDate));

          workOrderGroups[orderKey].displayDate =
            origDate.getTime() > newDate.getTime()
              ? workOrderGroups[orderKey].displayDate
              : displayDate;
        }
      });

      // --- Determin ranked status

      for (var key in workOrderGroups) {
        var rankedStatus = null;
        for (let i = 0; i < this.woStatusRanks.length; i++) {
          const status = this.woStatusRanks[i] ? this.woStatusRanks[i].toLowerCase().trim() : null;
          for (let j = 0; j < workOrderGroups[key].orders.length; j++) {
            const order = workOrderGroups[key].orders[j];
            const orderWoStatus = typeof order.woStatus == "string" ? order.woStatus.toLowerCase().trim() : null
            if(status === orderWoStatus) {
              rankedStatus = order.woStatus;
              break;
            }
          }
          if (rankedStatus) {
            break;
          }
        }
        if (!rankedStatus) {
          rankedStatus = workOrderGroups[key].woStatus;
        }
        workOrderGroups[key].rankedStatus = rankedStatus;
      }

      return workOrderGroups;
    },
    findWorkOrderDisplayNames(workOrder) {
      var displayNames = {};

      if (!this.serviceWasteStreamHash) {
        return displayNames;
      }

      var woServiceTypeTrimmed = workOrder.woServiceType
        ? workOrder.woServiceType.toLowerCase().trim()
        : "";
      for (let i = 0; i < this.serviceWasteStreamHash.length; i++) {
        const serviceHash = this.serviceWasteStreamHash[i];

        // Condition One: WorkerOrder's woServiceType matches service's api value
        var serviceApiTrimmed = serviceHash.api_value
          ? serviceHash.api_value.toLowerCase().trim()
          : "";
        if (woServiceTypeTrimmed != serviceApiTrimmed) {
          continue;
        }

        // Condition Two: All of the Waste woWasteTypes in the Work Order are found under the service
        var orders = workOrder.orders;
        var allWasteTypesMatched = true;
        for (let j = 0; j < orders.length; j++) {
          var woWasteType = orders[j].woWasteType;
          var woWasteTypeTrimmed = woWasteType
            ? woWasteType.toLowerCase().trim()
            : "";

          // Check and see if it's a WasteStreamCombo
          var matchingWasteStreamCombo = serviceHash.wasteStreamCombos.find(
            (wasteStreamCombo) => {
              var wasteStreamComboTrimmed = wasteStreamCombo.api_value
                ? wasteStreamCombo.api_value.toLowerCase().trim()
                : "";
              return woWasteTypeTrimmed == wasteStreamComboTrimmed;
            }
          );
          if (matchingWasteStreamCombo) {
            woWasteType =
              matchingWasteStreamCombo.primary_waste_stream_api_value;
            woWasteTypeTrimmed = woWasteType
              ? woWasteType.toLowerCase().trim()
              : "";
          }

          var matchingWasteStream = serviceHash.wasteStreams.find(
            (wasteStream) => {
              var wasteStreamTrimmed = wasteStream.api_value
                ? wasteStream.api_value.toLowerCase().trim()
                : "";
              return woWasteTypeTrimmed == wasteStreamTrimmed;
            }
          );
          if (!matchingWasteStream) {
            allWasteTypesMatched = false;
            break;
          }
        }

        if (allWasteTypesMatched) {
          displayNames = serviceHash;
          break;
        }
      }

      return displayNames;
    },
    getFormattedDate(date) {
      var newDate = new DateNoTz(date || new Date());
      return newDate.formatDdMonYyyy();
    },
    toSafariDate(date) {
      if (typeof date == "object")
        return (
          date.getUTCFullYear() +
          "-" +
          (date.getUTCMonth() + 1) +
          "-" +
          date.getUTCDate()
        );
      else return date;
    },
    computeBookingReferenceEntitlementsClaimedHash() {
      var hash = {};

      var addressEntitlementsList = this.$store.getters.GET_ADDRESS_ENTITLEMENT
        .list;
      if (Array.isArray(addressEntitlementsList)) {
        for (let i = 0; i < addressEntitlementsList.length; i++) {
          const addressEntitlements = addressEntitlementsList[i];
          if (Array.isArray(addressEntitlements.entitlementDetails)) {
            addressEntitlements.entitlementDetails.forEach(
              (entitlementDetail) => {
                var {
                  bookingReferenceNo,
                  entitlementsClaimed,
                  entitlementsCredited
                } = entitlementDetail;
                if(entitlementsCredited > 0){
                  hash[bookingReferenceNo.trim()] = "-" + entitlementsCredited;
                }
                else{
                  hash[bookingReferenceNo.trim()] = entitlementsClaimed;
                }
              }
            );
          }
        }
      }

      this.bookingReferenceEntitlementsClaimedHash = hash;
    },
    formatCrnForPrint(crnString){
      if(typeof crnString == "string" &&
        crnString.toLowerCase().indexOf('crn') == -1 &&
        crnString.toLowerCase().indexOf('ent') == -1 &&
        crnString.toLowerCase().indexOf('cwo') == -1
        ){

        return `CRN${crnString}`;
      }
      else{
        return crnString
      }
    },
    getWorkOrderComment(workOrder) {
      var text = workOrder.WOComments;
      if(text == '') return '';
      text = text.split('Selected Option')[0] || text;
      text = text.split('Paid Collection')[0] || text;
      text = text.split(parseInt(workOrder.woAmountPaid) + ' Bpoint receipt')[0] || text;
      text = text.split('Name ' + workOrder.Comments);
      return (text[1] || '').trim();
    },
    isShowWooStatusReasonDesc(desc) {
      var userType = this.personalInfo.type ? this.personalInfo.type.toLowerCase().trim() : 'resident';
      return desc && desc != '' && (userType == 'cso' || !!this.bookingSetting.show_woo_status_reason_desc)
    },
    getWorkOrderSelectedOption(workOrder, index = 0) {
      var text = workOrder.WOComments;
      if(text == '') return '';

      if(parseInt(workOrder.woAmountPaid) == 0) {
        if(text.includes('Collections 1')) {
          if(this.showWooStatusReasonDescFreeIndex == -1) {
            this.showWooStatusReasonDescFreeIndex = index;
          }
          return '1 Entitlement: 1-2 cubic metres';
        }

        if(text.includes('Collections 2')) {
          if(this.showWooStatusReasonDescFreeIndex == -1) {
            this.showWooStatusReasonDescFreeIndex = index;
          }
          return '2 Entitlements: 3-4 cubic metres';
        }
      }

      if(parseInt(workOrder.woAmountPaid) > 0) {
        text = text.split('Selected Option')[1] || '';
        text = text.split('Paid Collection')[0] || text;
        text = text.replace('12 cubic', '1-2 cubic');
        text = text.replace('34 cubic', '3-4 cubic');
        return text.trim();
      }
      
      return '';
    }
  },
  watch: {
    addressEntitlementsList(newValue) {
      if (newValue) {
        this.computeBookingReferenceEntitlementsClaimedHash();
      }
    },
  },
};
</script>

<style scoped>
.vw-small {
  font-size: 0.8rem;
}
</style>